import { definicion as bodaEditorial } from "./wedding-editorial/definicion";
import { definicion as bodaAtelier } from "./boda-atelier/definicion";
import { definicion as civilEsencial } from "./civil-esencial/definicion";
import { definicion as quinceLumina } from "./quince-lumina/definicion";
import { definicion as quinceNova } from "./quince-nova/definicion";
import { definicion as infantilFiesta } from "./infantil-fiesta/definicion";
import { definicion as infantilEspacial } from "./infantil-espacial/definicion";
import { definicion as infantilMariposas } from "./infantil-mariposas/definicion";
import { definicion as formalPrisma } from "./formal-prisma/definicion";
import { definicion as bautismoAlba } from "./bautismo-alba/definicion";

// Registro del catálogo. Para agregar una plantilla: crear su carpeta con
// definicion.js y sumarla aquí. Ver GUIA_CATALOGO.md.
export const PLANTILLAS = [
  bodaEditorial,
  bodaAtelier,
  civilEsencial,
  quinceLumina,
  quinceNova,
  infantilFiesta,
  infantilEspacial,
  infantilMariposas,
  formalPrisma,
  bautismoAlba,
];

export const TIPOS_EVENTO = [
  { id: "todos", etiqueta: "Todos" },
  { id: "boda", etiqueta: "Boda" },
  { id: "civil", etiqueta: "Civil íntimo" },
  { id: "quince", etiqueta: "15 años" },
  { id: "infantil", etiqueta: "Cumpleaños infantil" },
  { id: "bautismo", etiqueta: "Bautismo" },
  { id: "formal", etiqueta: "Evento formal" },
];
